interface EnrollResponse {
	request_id: string;
	status_code: string;
	user_message_title: string;
	user_message_desc: string;
	body_signature: string;
	data: {
		retry: boolean;
	};
}

interface Data {
	retry: boolean;
}

function isEnrollResponse(obj: any): obj is EnrollResponse {
	return obj && 
	typeof obj.request_id === 'string' && 
	typeof obj.status_code === 'string' && 
	typeof obj.user_message_title === 'string' && 
	typeof obj.user_message_desc === 'string' && 
	typeof obj.body_signature === 'string' && 
	typeof obj.data === 'object' && 
	typeof obj.data.retry === 'boolean';
}

export class EnrollDto {
	requestID: string;
	statusCode: string;
	userMessageTitle: string;
	userMessageDesc: string;
	bodySignature: string;
	data: Data;

	constructor(json: EnrollResponse) {
		if (!isEnrollResponse(json)) {
			throw new Error('Invalid EnrollResponse json');
		}
		this.requestID = json.request_id;
		this.statusCode = json.status_code;
		this.userMessageTitle = json.user_message_title;
		this.userMessageDesc = json.user_message_desc;
		this.bodySignature = json.body_signature;
		this.data = {
			retry: json.data.retry
		};
	}
}
